import React, { Component } from "react";
// import Slider from "react-rangeslider";
// import "react-rangeslider/lib/index.css";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

class rangeSlider extends Component<any, any> {
  constructor(props: any, context: any) {
    super(props, context);
    this.state = {
      value: 10,
    };
  }

  handleChange = (value: any) => {
    this.setState({
      value: value,
    });
  };

  render() {
    const { value } = this.state;
    return (
      <div className="slider">
        <Slider min={0} max={100} value={value} onChange={this.handleChange} />
        <div className="value">{value}</div>
      </div>
    );
  }
}

export default rangeSlider;
